import {Injectable, Pipe, PipeTransform} from '@angular/core';
import { MeasurementPrecisionTypes } from '@model';
import {MillisecondsToPrecisionPipe} from "./milliseconds-to-precision.pipe";

@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'stringTimeToPrecision'
})
export class StringTimeToPrecisionPipe implements PipeTransform {

  constructor(private millisecondsToPrecisionPipe: MillisecondsToPrecisionPipe) {}
  transform(time: string|undefined, measurementPrecisionType: MeasurementPrecisionTypes): string {
    if (!time) return '';
    const [hh, mm, ssMs] = time.split(':');
    if (!ssMs) return "";
    let [ss, ms = '000'] = ssMs.split('.');

    ms = ms.padEnd(3, '0');

    const milliseconds = (parseInt(hh) * 3600000) + (parseInt(mm) * 60000) + (parseInt(ss) * 1000) + parseInt(ms.padEnd(3, '0'));

    return this.millisecondsToPrecisionPipe.transform(milliseconds, measurementPrecisionType);
  }
}
